/**
 * The two small glyphs the public nav uses for account links. Kept together so
 * the landing page and the pricing page cannot drift into different thicknesses
 * or viewboxes.
 */

export function IconUser() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 20 20"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    >
      <circle cx="10" cy="10" r="7.4" />
      <circle cx="10" cy="8.3" r="2.4" />
      <path d="M5.8 15.9a4.9 4.9 0 0 1 8.4 0" strokeLinecap="round" />
    </svg>
  );
}

export function IconGrid() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 20 20"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    >
      <rect x="2.8" y="2.8" width="5.6" height="5.6" rx="1.2" />
      <rect x="11.6" y="2.8" width="5.6" height="5.6" rx="1.2" />
      <rect x="2.8" y="11.6" width="5.6" height="5.6" rx="1.2" />
      <rect x="11.6" y="11.6" width="5.6" height="5.6" rx="1.2" />
    </svg>
  );
}
